import { Outlet } from "react-router-dom";
import { MainNavigation } from "./navigation";
import { Box } from "@mui/material";

export function MainLayout() {
  return (
    <Box className="animate__animated animate__fadeIn">
      <MainNavigation />

      <Box minHeight="100vh">
        <Outlet />
      </Box>
    </Box>
  );
}
